<template>
	<layout-splash>
		<div class="h-full w-96">
			<button v-on:click="submit()">
				<img :src="buttonUrl" />
			</button>
		</div>
	</layout-splash>
</template>

<script>
export default {
	data() {
		return {
			form: this.$inertia.form({}),
		};
	},
	methods: {
		submit() {
			this.form.post(this.$route("logout"));
		},
	},
	computed: {
		buttonUrl() {
			return window.baseUrl + "/images/hotbutton.gif";
		},
	},
};
</script>
